<template>
  <v-container class="mt-4 px-5" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title class="text-subtitle-1">
            Reporte — Teachers activos
            <v-spacer />
            <v-btn
              small
              dark
              color="primary"
              tile
              :loading="cargar"
              @click="consultarPorCiclo"
            >
              <v-icon small left>mdi-filter</v-icon>
              Filtrar por ciclo
            </v-btn>
            <v-btn
              class="ml-2"
              small
              dark
              color="secondary"
              tile
              @click="mostrarTodosActivos"
            >
              <v-icon small left>mdi-account-group</v-icon>
              Todos los activos
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-btn-toggle
              v-model="seccionVista"
              mandatory
              dense
              color="primary"
              class="mb-4"
            >
              <v-btn value="teacher" small tile>Por teacher</v-btn>
              <v-btn value="plantel" small tile>Por plantel</v-btn>
            </v-btn-toggle>

            <template v-if="seccionVista === 'teacher'">
            <!-- KPIs sección teacher -->
            <v-row class="mb-4">
              <v-col cols="6" sm="6" md="3">
                <v-sheet rounded elevation="1" class="pa-4 text-center" color="blue-grey lighten-5">
                  <div class="text-caption grey--text text--darken-1">Teachers en vista</div>
                  <div class="text-h5 font-weight-medium primary--text">{{ kpi.teachers }}</div>
                </v-sheet>
              </v-col>
              <v-col cols="6" sm="6" md="3">
                <v-sheet rounded elevation="1" class="pa-4 text-center" color="teal lighten-5">
                  <div class="text-caption grey--text text--darken-1">Total obligaciones (slots)</div>
                  <div class="text-h5 font-weight-medium teal--text text--darken-2">{{ kpi.totalClases }}</div>
                </v-sheet>
              </v-col>
              <v-col cols="6" sm="6" md="3">
                <v-sheet rounded elevation="1" class="pa-4 text-center" color="amber lighten-5">
                  <div class="text-caption grey--text text--darken-1">Total faltas</div>
                  <div class="text-h5 font-weight-medium amber--text text--darken-3">{{ kpi.totalFaltas }}</div>
                </v-sheet>
              </v-col>
              <v-col cols="6" sm="6" md="3">
                <v-sheet rounded elevation="1" class="pa-4 text-center" color="indigo lighten-5">
                  <div class="text-caption grey--text text--darken-1">% Fiabilidad global</div>
                  <div class="text-h5 font-weight-medium indigo--text text--darken-2">{{ kpi.fiabilidadGlobal }}</div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row align="center">
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  v-model="ciclo"
                  :items="ciclos"
                  label="Ciclo"
                  filled
                  dense
                  clearable
                  hide-details
                  return-object
                  item-text="ciclo"
                  item-value="id_ciclo"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="search"
                  label="Buscar"
                  filled
                  dense
                  clearable
                  hide-details
                  append-icon="mdi-magnify"
                />
              </v-col>
              <v-col cols="12" md="4" class="text-caption grey--text text--darken-1">
                <span v-if="modoLista === 'ciclo' && ciclo">
                  Teachers con rol en <strong>{{ ciclo.ciclo }}</strong>.
                  <span v-if="filasRolCiclo.length" class="ml-1">
                    <strong>{{ filasRolCiclo.length }}</strong> grupo(s). Faltas: celda del bloque ≠ maestro oficial
                    (<code class="text-caption">id_teacher</code> → lu/ma/mi;
                    <code class="text-caption">id_teacher_2</code> → ju/vi). Incluye ONLINE. Sáb/dom no TEENS: LU+MA+MI y JU+VI por semana cuentan como 1 obligación / 1 falta por bloque.
                  </span>
                </span>
                <span v-else-if="modoLista === 'todos'">
                  Todos los teachers activos. <strong>Filtra por ciclo</strong> para ver clases, faltas y fiabilidad.
                </span>
                <span v-else> Elige ciclo o «Todos los activos». </span>
              </v-col>
            </v-row>

            <v-data-table
              class="elevation-1 mt-4"
              :headers="headers"
              :items="itemsTabla"
              :search="search"
              :loading="cargar"
              dense
              :items-per-page="25"
              :footer-props="{ 'items-per-page-options': [10, 25, 50, 100, -1] }"
            >
              <template v-slot:item.id_plantel="{ item }">
                {{ nombrePlantel(item.id_plantel) }}
              </template>
              <template v-slot:item.totalClases="{ item }">
                {{ formatoMetrica(item.totalClases) }}
              </template>
              <template v-slot:item.totalFaltas="{ item }">
                {{ formatoMetrica(item.totalFaltas) }}
              </template>
              <template v-slot:item.fiabilidadPct="{ item }">
                {{ formatoFiabilidad(item.fiabilidadPct) }}
              </template>
              <template v-slot:item.accionFaltas="{ item }">
                <v-chip
                  v-if="tieneDatosRol"
                  small
                  :color="(item.totalFaltas || 0) > 0 ? 'error' : 'success'"
                  text-color="white"
                  @click="abrirDialogFaltas(item)"
                >
                  <v-icon left x-small>mdi-alert-circle-outline</v-icon>
                  {{ item.totalFaltas || 0 }} falta(s)
                </v-chip>
                <span v-else class="text-caption grey--text">—</span>
              </template>
            </v-data-table>
            </template>

            <template v-else-if="seccionVista === 'plantel'">
            <p class="text-caption grey--text text--darken-1 mb-3">
              Mismas reglas que «Por teacher», acumuladas por plantel del grupo (celda ≠ teacher oficial = falta).
              <strong>FAST</strong>: nombre de plantel contiene «FAST»; el resto cuenta como <strong>INBI</strong>.
            </p>

            <v-row align="center" class="mb-2">
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="filtroEscuela"
                  :items="opcionesFiltroEscuela"
                  label="Escuela"
                  filled
                  dense
                  hide-details
                />
              </v-col>
            </v-row>

            <!-- KPIs sección plantel -->
            <v-row class="mb-4">
              <v-col cols="6" sm="6" md="3">
                <v-sheet rounded elevation="1" class="pa-4 text-center" color="blue-grey lighten-5">
                  <div class="text-caption grey--text text--darken-1">Planteles en vista</div>
                  <div class="text-h5 font-weight-medium primary--text">{{ kpiPlantel.planteles }}</div>
                </v-sheet>
              </v-col>
              <v-col cols="6" sm="6" md="3">
                <v-sheet rounded elevation="1" class="pa-4 text-center" color="teal lighten-5">
                  <div class="text-caption grey--text text--darken-1">Total obligaciones (slots)</div>
                  <div class="text-h5 font-weight-medium teal--text text--darken-2">{{ kpiPlantel.totalClases }}</div>
                </v-sheet>
              </v-col>
              <v-col cols="6" sm="6" md="3">
                <v-sheet rounded elevation="1" class="pa-4 text-center" color="amber lighten-5">
                  <div class="text-caption grey--text text--darken-1">Total faltas</div>
                  <div class="text-h5 font-weight-medium amber--text text--darken-3">{{ kpiPlantel.totalFaltas }}</div>
                </v-sheet>
              </v-col>
              <v-col cols="6" sm="6" md="3">
                <v-sheet rounded elevation="1" class="pa-4 text-center" color="indigo lighten-5">
                  <div class="text-caption grey--text text--darken-1">% Fiabilidad global</div>
                  <div class="text-h5 font-weight-medium indigo--text text--darken-2">{{ kpiPlantel.fiabilidadGlobal }}</div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-row align="center">
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="searchPlantel"
                  label="Buscar plantel"
                  filled
                  dense
                  clearable
                  hide-details
                  append-icon="mdi-magnify"
                />
              </v-col>
            </v-row>

            <v-data-table
              class="elevation-1 mt-4"
              :headers="headersPlantel"
              :items="itemsTablaPlantel"
              :search="searchPlantel"
              :loading="cargar"
              dense
              :items-per-page="25"
              :footer-props="{ 'items-per-page-options': [10, 25, 50, 100, -1] }"
            >
              <template v-slot:item.totalClases="{ item }">
                {{ formatoMetrica(item.totalClases) }}
              </template>
              <template v-slot:item.totalFaltas="{ item }">
                {{ formatoMetrica(item.totalFaltas) }}
              </template>
              <template v-slot:item.fiabilidadPct="{ item }">
                {{ formatoFiabilidad(item.fiabilidadPct) }}
              </template>
              <template v-slot:item.accionFaltas="{ item }">
                <v-chip
                  v-if="tieneDatosRol"
                  small
                  :color="(item.totalFaltas || 0) > 0 ? 'error' : 'success'"
                  text-color="white"
                  @click="abrirDialogFaltasPlantel(item)"
                >
                  <v-icon left x-small>mdi-alert-circle-outline</v-icon>
                  {{ item.totalFaltas || 0 }} falta(s)
                </v-chip>
                <span v-else class="text-caption grey--text">—</span>
              </template>
            </v-data-table>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogFaltas" max-width="720">
      <v-card>
        <v-card-title class="subtitle-1">
          Faltas — {{ modoFaltasDialog === 'teacher' ? faltasSeleccion.nombre_completo : faltasSeleccion.nombre_plantel }}
          <v-spacer />
          <v-btn icon small @click="dialogFaltas = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <p v-if="!detalleFaltasLista.length" class="text-body-2">No hay faltas registradas en los slots de este ciclo.</p>
          <v-data-table
            v-else
            dense
            class="elevation-0"
            :headers="modoFaltasDialog === 'teacher' ? headersDetalleFaltas : headersDetalleFaltasPlantel"
            :items="detalleFaltasLista"
            hide-default-footer
            :items-per-page="-1"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'

/** Normaliza id de teacher (0 = vacío / sin asignar). */
function idNum(v) {
  if (v == null || v === '' || String(v).toUpperCase() === 'SIN TEACHER') return 0
  const n = Number(v)
  return Number.isNaN(n) ? 0 : n
}

function campoOficial(grupo, tf) {
  if (tf === 'id_teacher') {
    return idNum(grupo.id_teacher != null ? grupo.id_teacher : grupo.id_Teacher)
  }
  return idNum(grupo.id_teacher_2)
}

/** Sábado no TEENS: mismas filas que contarRetardosGrupo (por semana de bloques). */
const SABADO_NO_TEENS_POR_SEMANA = [
  [
    { tf: 'id_teacher', s: 'lu1' },
    { tf: 'id_teacher', s: 'ma1' },
    { tf: 'id_teacher', s: 'mi1' },
    { tf: 'id_teacher_2', s: 'ju1' },
    { tf: 'id_teacher_2', s: 'vi1' },
  ],
  [
    { tf: 'id_teacher', s: 'lu2' },
    { tf: 'id_teacher', s: 'ma2' },
    { tf: 'id_teacher', s: 'mi2' },
    { tf: 'id_teacher_2', s: 'ju2' },
    { tf: 'id_teacher_2', s: 'vi2' },
  ],
  [
    { tf: 'id_teacher', s: 'lu3' },
    { tf: 'id_teacher', s: 'ma3' },
    { tf: 'id_teacher', s: 'mi3' },
    { tf: 'id_teacher_2', s: 'ju3' },
    { tf: 'id_teacher_2', s: 'vi3' },
  ],
  [
    { tf: 'id_teacher', s: 'lu4' },
    { tf: 'id_teacher', s: 'ma4' },
    { tf: 'id_teacher', s: 'mi4' },
    { tf: 'id_teacher_2', s: 'ju4' },
    { tf: 'id_teacher_2', s: 'vi4' },
  ],
  [
    { tf: 'id_teacher', s: 'lu5' },
    { tf: 'id_teacher', s: 'ma5' },
    { tf: 'id_teacher', s: 'mi5' },
    { tf: 'id_teacher_2', s: 'ju5' },
    { tf: 'id_teacher_2', s: 'vi5' },
  ],
]

/** Domingo no TEENS: misma lista que contarRetardosGrupo. */
const DOMINGO_NO_TEENS = [
  ['id_teacher', 'lu1'],
  ['id_teacher', 'ma1'],
  ['id_teacher', 'mi1'],
  ['id_teacher_2', 'ju1'],
  ['id_teacher_2', 'vi1'],
  ['id_teacher', 'lu2'],
  ['id_teacher_2', 'ju2'],
  ['id_teacher_2', 'ju3'],
  ['id_teacher', 'lu4'],
  ['id_teacher_2', 'ju4'],
  ['id_teacher', 'lu5'],
  ['id_teacher', 'ma5'],
  ['id_teacher', 'mi5'],
  ['id_teacher_2', 'ju5'],
  ['id_teacher_2', 'vi5'],
]

/**
 * Lista de { dia, tf, slot } a evaluar: oficial en tf debe coincidir con valor en slot.
 * Incluye ONLINE; excluir grupos con deleted==1 en el caller.
 */
function construirChequeosOficiales(grupo) {
  const checks = []
  const esTeens = /TEENS/.test(grupo.grupo || '')

  for (let sem = 1; sem <= 4; sem++) {
    if (grupo.lunes == 1) checks.push({ dia: 'lunes', tf: 'id_teacher', slot: `lu${sem}` })
    if (grupo.martes == 1) checks.push({ dia: 'martes', tf: 'id_teacher', slot: `ma${sem}` })
    if (grupo.miercoles == 1) checks.push({ dia: 'miercoles', tf: 'id_teacher', slot: `mi${sem}` })
    if (grupo.jueves == 1) checks.push({ dia: 'jueves', tf: 'id_teacher_2', slot: `ju${sem}` })
    if (grupo.viernes == 1) checks.push({ dia: 'viernes', tf: 'id_teacher_2', slot: `vi${sem}` })
  }

  if (grupo.sabado == 1) {
    if (esTeens) {
      for (let sem = 1; sem <= 4; sem++) {
        checks.push({ dia: 'sabado', tf: 'id_teacher', slot: `lu${sem}` })
        checks.push({ dia: 'sabado', tf: 'id_teacher', slot: `ma${sem}` })
      }
      checks.push({ dia: 'sabado', tf: 'id_teacher_2', slot: 'ju5' })
      checks.push({ dia: 'sabado', tf: 'id_teacher_2', slot: 'vi5' })
    } else {
      for (const slots of SABADO_NO_TEENS_POR_SEMANA) {
        for (const { tf, s } of slots) {
          checks.push({ dia: 'sabado', tf, slot: s })
        }
      }
    }
  }

  if (grupo.domingo == 1) {
    if (esTeens) {
      for (let sem = 1; sem <= 4; sem++) {
        checks.push({ dia: 'domingo', tf: 'id_teacher', slot: `lu${sem}` })
        checks.push({ dia: 'domingo', tf: 'id_teacher', slot: `ma${sem}` })
      }
    } else {
      for (const [tf, s] of DOMINGO_NO_TEENS) {
        checks.push({ dia: 'domingo', tf, slot: s })
      }
    }
  }

  return checks
}

function semanaDesdeSlot(slot) {
  const m = String(slot).match(/(\d+)$/)
  return m ? m[1] : '—'
}

/**
 * Sábado/Domingo (no TEENS): LU+MA+MI de la misma semana = 1 obligación / 1 falta como bloque;
 * JU+VI de la misma semana = 1 obligación / 1 falta. El resto de días no se agrupa.
 */
function agruparChequeosSabDomNoTeens(grupo, checks) {
  const esTeens = /TEENS/.test(grupo.grupo || '')
  if (esTeens) {
    return checks.map((c) => ({ modo: 'single', ...c }))
  }

  const buckets = {}
  const resultado = []

  for (const c of checks) {
    if (c.dia !== 'sabado' && c.dia !== 'domingo') {
      resultado.push({ modo: 'single', ...c })
      continue
    }
    const w = semanaDesdeSlot(c.slot)
    if (w === '—') {
      resultado.push({ modo: 'single', ...c })
      continue
    }
    const s = String(c.slot).toLowerCase()
    let kind = null
    if (/^lu\d+$|^ma\d+$|^mi\d+$/.test(s)) kind = 'lmm'
    else if (/^ju\d+$|^vi\d+$/.test(s)) kind = 'jv'
    else {
      resultado.push({ modo: 'single', ...c })
      continue
    }
    const key = `${c.dia}|${w}|${kind}`
    if (!buckets[key]) buckets[key] = []
    buckets[key].push(c)
  }

  const ordenKeys = Object.keys(buckets).sort((a, b) => {
    const [da, wa, ka] = a.split('|')
    const [db, wb, kb] = b.split('|')
    if (da !== db) return da.localeCompare(db)
    if (Number(wa) !== Number(wb)) return Number(wa) - Number(wb)
    return ka === 'lmm' ? -1 : 1
  })

  for (const key of ordenKeys) {
    const arr = buckets[key]
    const parts = key.split('|')
    const dia = parts[0]
    const w = parts[1]
    const kind = parts[2]
    const tf = kind === 'lmm' ? 'id_teacher' : 'id_teacher_2'
    const minParaGrupo = kind === 'lmm' ? 2 : 2
    if (arr.length >= minParaGrupo) {
      resultado.push({
        modo: 'grupo',
        dia,
        semana: w,
        kind,
        tf,
        slots: arr.map((x) => x.slot),
      })
    } else {
      arr.forEach((c) => resultado.push({ modo: 'single', ...c }))
    }
  }

  return resultado
}

export default {
  name: 'ReporteAsistenciaTeacher',

  components: { Alerta, carga },

  mixins: [validarErrores],

  data: () => ({
    parametros: { dialogError: false, mensaje: '', color: '' },
    respuestaAlerta: false,
    cargar: false,

    ciclos: [],
    ciclo: null,
    planteles: [],

    teachersActivos: [],
    listaTeachers: [],
    /**
     * Respuesta completa de POST `rol.clases` (misma consulta que «Mi rol de clases» / asistencia teacher).
     * Suele incluir `respuesta`, `ultimaActualizacion`, etc.
     */
    respuestaRolClasesCompleta: null,
    /** Filas planas de `rol.clases`: lu1…vi5, id_teacher, id_teacher_2, flags de día, etc. */
    filasRolCiclo: [],

    modoLista: '',

    search: '',
    searchPlantel: '',
    /** Vista: solo una sección a la vez */
    seccionVista: 'teacher',
    /** Por plantel: FAST = nombre contiene FAST; INBI = resto */
    filtroEscuela: 'todos',
    opcionesFiltroEscuela: [
      { text: 'Todas las escuelas', value: 'todos' },
      { text: 'FAST', value: 'fast' },
      { text: 'INBI', value: 'inbi' },
    ],
    modoFaltasDialog: 'teacher',
    headers: [
      { text: 'ID usuario', value: 'id_usuario', width: '100' },
      { text: 'Nombre completo', value: 'nombre_completo' },
      { text: 'Plantel', value: 'id_plantel', width: '160' },
      { text: 'Obligaciones', value: 'totalClases', width: '110', align: 'end' },
      { text: 'Total faltas', value: 'totalFaltas', width: '110', align: 'end' },
      { text: '% Fiabilidad', value: 'fiabilidadPct', width: '120', align: 'end' },
      { text: 'Faltas', value: 'accionFaltas', sortable: false, width: '140' },
    ],
    headersDetalleFaltas: [
      { text: 'Grupo', value: 'grupo' },
      { text: 'Día', value: 'dia', width: '100' },
      { text: 'Semana', value: 'semana', width: '90' },
      { text: 'Bloque', value: 'bloque' },
    ],
    headersPlantel: [
      { text: 'Plantel', value: 'nombre_plantel' },
      { text: 'Obligaciones', value: 'totalClases', width: '110', align: 'end' },
      { text: 'Total faltas', value: 'totalFaltas', width: '110', align: 'end' },
      { text: '% Fiabilidad', value: 'fiabilidadPct', width: '120', align: 'end' },
      { text: 'Faltas', value: 'accionFaltas', sortable: false, width: '140' },
    ],
    headersDetalleFaltasPlantel: [
      { text: 'Grupo', value: 'grupo' },
      { text: 'Teacher oficial', value: 'maestro', width: '160' },
      { text: 'Día', value: 'dia', width: '100' },
      { text: 'Semana', value: 'semana', width: '90' },
      { text: 'Bloque', value: 'bloque' },
    ],

    dialogFaltas: false,
    faltasSeleccion: {},
    detalleFaltasLista: [],
  }),

  computed: {
    tieneDatosRol() {
      return Array.isArray(this.filasRolCiclo) && this.filasRolCiclo.length > 0
    },

    itemsTabla() {
      return [...this.listaTeachers]
        .map((t) => {
          const m = this.metricasParaTeacher(t.id_usuario)
          return { ...t, ...m }
        })
        .sort((a, b) => {
          const na = (a.nombre_completo || '').toString()
          const nb = (b.nombre_completo || '').toString()
          return na.localeCompare(nb, 'es', { sensitivity: 'base' })
        })
    },

    totalLista() {
      return this.listaTeachers.length
    },

    kpi() {
      const teachers = this.totalLista
      if (!this.tieneDatosRol) {
        return {
          teachers,
          totalClases: '—',
          totalFaltas: '—',
          fiabilidadGlobal: '—',
        }
      }
      let sumClases = 0
      let sumFaltas = 0
      for (const t of this.listaTeachers) {
        const m = this.metricasParaTeacher(t.id_usuario)
        sumClases += m.totalClases || 0
        sumFaltas += m.totalFaltas || 0
      }
      const fiab =
        sumClases > 0 ? Math.round(((sumClases - sumFaltas) / sumClases) * 1000) / 10 : 0
      return {
        teachers,
        totalClases: sumClases,
        totalFaltas: sumFaltas,
        fiabilidadGlobal: `${fiab} %`,
      }
    },

    mapMetricasPorPlantel() {
      if (!this.tieneDatosRol) return {}
      const map = {}
      for (const row of this.filasRolCiclo) {
        if (row.deleted == 1) continue
        if (!this.pasaFiltroEscuelaPlantel(row.id_plantel)) continue
        const pid = row.id_plantel
        const key = pid != null && pid !== '' ? String(pid) : '—'
        if (!map[key]) map[key] = { totalClases: 0, totalFaltas: 0 }
        const checks = construirChequeosOficiales(row)
        const bloques = agruparChequeosSabDomNoTeens(row, checks)
        for (const b of bloques) {
          if (b.modo === 'single') {
            const { tf, slot } = b
            const oficial = campoOficial(row, tf)
            if (!oficial) continue
            map[key].totalClases++
            const celda = idNum(row[slot])
            if (celda !== oficial) map[key].totalFaltas++
          } else {
            const { tf, slots } = b
            const oficial = campoOficial(row, tf)
            if (!oficial) continue
            map[key].totalClases++
            const falta = slots.some((slot) => idNum(row[slot]) !== oficial)
            if (falta) map[key].totalFaltas++
          }
        }
      }
      return map
    },

    itemsTablaPlantel() {
      if (!this.tieneDatosRol) return []
      const map = this.mapMetricasPorPlantel
      return Object.keys(map)
        .map((key) => {
          const m = map[key]
          const idPlantel = key === '—' ? null : key
          const fiab =
            m.totalClases > 0
              ? Math.round(((m.totalClases - m.totalFaltas) / m.totalClases) * 1000) / 10
              : null
          return {
            id_plantel: idPlantel,
            nombre_plantel: this.nombrePlantel(idPlantel),
            totalClases: m.totalClases,
            totalFaltas: m.totalFaltas,
            fiabilidadPct: fiab,
          }
        })
        .sort((a, b) =>
          String(a.nombre_plantel).localeCompare(String(b.nombre_plantel), 'es', { sensitivity: 'base' })
        )
    },

    kpiPlantel() {
      if (!this.tieneDatosRol) {
        return {
          planteles: '—',
          totalClases: '—',
          totalFaltas: '—',
          fiabilidadGlobal: '—',
        }
      }
      const map = this.mapMetricasPorPlantel
      const keys = Object.keys(map)
      let sumClases = 0
      let sumFaltas = 0
      for (const k of keys) {
        sumClases += map[k].totalClases || 0
        sumFaltas += map[k].totalFaltas || 0
      }
      const fiab =
        sumClases > 0 ? Math.round(((sumClases - sumFaltas) / sumClases) * 1000) / 10 : 0
      return {
        planteles: keys.length,
        totalClases: sumClases,
        totalFaltas: sumFaltas,
        fiabilidadGlobal: `${fiab} %`,
      }
    },
  },

  async created() {
    await Promise.all([this.obtenerCiclos(), this.getPlanteles(), this.cargarTeachersActivos()])
    this.mostrarTodosActivos()
  },

  methods: {
    formatoMetrica(v) {
      if (v == null) return '—'
      return v
    },

    formatoFiabilidad(v) {
      if (v == null) return '—'
      return `${v} %`
    },

    /**
     * Obligaciones: chequeos donde el maestro oficial (`id_teacher` o `id_teacher_2` según bloque) es este usuario.
     * Faltas: entre esos, celda del slot ≠ id oficial (vacío/0 cuenta como falta).
     */
    metricasParaTeacher(idUsuario) {
      if (!this.tieneDatosRol) {
        return { totalClases: null, totalFaltas: null, fiabilidadPct: null }
      }
      const id = Number(idUsuario)
      let totalClases = 0
      let totalFaltas = 0
      for (const row of this.filasRolCiclo) {
        if (row.deleted == 1) continue
        const checks = construirChequeosOficiales(row)
        const bloques = agruparChequeosSabDomNoTeens(row, checks)
        for (const b of bloques) {
          if (b.modo === 'single') {
            const { tf, slot } = b
            const oficial = campoOficial(row, tf)
            if (oficial !== id) continue
            totalClases++
            const celda = idNum(row[slot])
            if (celda !== oficial) totalFaltas++
          } else {
            const { tf, slots } = b
            const oficial = campoOficial(row, tf)
            if (oficial !== id) continue
            totalClases++
            const falta = slots.some((slot) => idNum(row[slot]) !== oficial)
            if (falta) totalFaltas++
          }
        }
      }
      const fiabilidadPct =
        totalClases > 0 ? Math.round(((totalClases - totalFaltas) / totalClases) * 1000) / 10 : null
      return { totalClases, totalFaltas, fiabilidadPct }
    },

    detalleFaltasParaTeacher(idUsuario) {
      const id = Number(idUsuario)
      const rows = []
      for (const row of this.filasRolCiclo) {
        if (row.deleted == 1) continue
        const checks = construirChequeosOficiales(row)
        const bloques = agruparChequeosSabDomNoTeens(row, checks)
        for (const b of bloques) {
          if (b.modo === 'single') {
            const { dia, tf, slot } = b
            const oficial = campoOficial(row, tf)
            if (oficial !== id) continue
            const celda = idNum(row[slot])
            if (celda === oficial) continue
            rows.push({
              grupo: row.grupo || row.nombre_grupo || '—',
              dia,
              semana: `Sem. ${semanaDesdeSlot(slot)}`,
              bloque: String(slot).toUpperCase(),
            })
          } else {
            const { dia, semana, kind, tf, slots } = b
            const oficial = campoOficial(row, tf)
            if (oficial !== id) continue
            const falta = slots.some((slot) => idNum(row[slot]) !== oficial)
            if (!falta) continue
            const etiqueta = kind === 'lmm' ? 'LU+MA+MI' : 'JU+VI'
            rows.push({
              grupo: row.grupo || row.nombre_grupo || '—',
              dia,
              semana: `Sem. ${semana}`,
              bloque: etiqueta,
            })
          }
        }
      }
      return rows
    },

    abrirDialogFaltas(item) {
      this.modoFaltasDialog = 'teacher'
      this.faltasSeleccion = item
      this.detalleFaltasLista = this.detalleFaltasParaTeacher(item.id_usuario)
      this.dialogFaltas = true
    },

    abrirDialogFaltasPlantel(item) {
      this.modoFaltasDialog = 'plantel'
      this.faltasSeleccion = item
      this.detalleFaltasLista = this.detalleFaltasParaPlantel(item.id_plantel)
      this.dialogFaltas = true
    },

    nombreMaestro(idUsuario) {
      if (idUsuario == null || idUsuario === '') return '—'
      const id = Number(idUsuario)
      const t = this.teachersActivos.find((u) => Number(u.id_usuario) === id)
      return t ? t.nombre_completo : 'ID ' + id
    },

    detalleFaltasParaPlantel(idPlantel) {
      const rows = []
      const coincidePlantel = (row) => {
        const pid = row.id_plantel
        if (idPlantel == null || idPlantel === '' || idPlantel === '—') {
          return pid == null || pid === ''
        }
        return String(pid) === String(idPlantel)
      }
      for (const row of this.filasRolCiclo) {
        if (row.deleted == 1) continue
        if (!coincidePlantel(row)) continue
        const checks = construirChequeosOficiales(row)
        const bloques = agruparChequeosSabDomNoTeens(row, checks)
        for (const b of bloques) {
          if (b.modo === 'single') {
            const { dia, tf, slot } = b
            const oficial = campoOficial(row, tf)
            if (!oficial) continue
            const celda = idNum(row[slot])
            if (celda === oficial) continue
            rows.push({
              grupo: row.grupo || row.nombre_grupo || '—',
              maestro: this.nombreMaestro(oficial),
              dia,
              semana: `Sem. ${semanaDesdeSlot(slot)}`,
              bloque: String(slot).toUpperCase(),
            })
          } else {
            const { dia, semana, kind, tf, slots } = b
            const oficial = campoOficial(row, tf)
            if (!oficial) continue
            const falta = slots.some((slot) => idNum(row[slot]) !== oficial)
            if (!falta) continue
            const etiqueta = kind === 'lmm' ? 'LU+MA+MI' : 'JU+VI'
            rows.push({
              grupo: row.grupo || row.nombre_grupo || '—',
              maestro: this.nombreMaestro(oficial),
              dia,
              semana: `Sem. ${semana}`,
              bloque: etiqueta,
            })
          }
        }
      }
      return rows
    },

    nombrePlantel(id) {
      if (id == null || id === '') return '—'
      const p = this.planteles.find((el) => el.id_plantel == id)
      return p ? p.plantel : id
    },

    /** FAST si el nombre del plantel contiene FAST (insensible a mayúsculas). */
    esPlantelFastPorId(idPlantel) {
      const nombre = this.nombrePlantel(idPlantel)
      return /fast/i.test(String(nombre))
    },

    pasaFiltroEscuelaPlantel(idPlantel) {
      if (this.filtroEscuela === 'todos') return true
      const esFast = this.esPlantelFastPorId(idPlantel)
      if (this.filtroEscuela === 'fast') return esFast
      if (this.filtroEscuela === 'inbi') return !esFast
      return true
    },

    obtenerCiclos() {
      this.ciclos = []
      return this.$http
        .get('roles.ciclos.all')
        .then((response) => {
          for (const i in response.data) {
            const row = response.data[i]
            if (!row.ciclo) continue
            if (!(row.ciclo.search('FE') !== -1) && row.ciclo.search('CICLO') !== -1) {
              this.ciclos.push(row)
            }
          }
        })
        .catch((error) => {
          this.validarError(error.response && error.response.data ? error.response.data.message : 'Error al cargar ciclos')
        })
    },

    getPlanteles() {
      return this.$http
        .get('planteles.activos')
        .then((response) => {
          this.planteles = response.data || []
        })
        .catch((error) => {
          this.validarError(error.response && error.response.data ? error.response.data.message : 'Error al cargar planteles')
        })
    },

    cargarTeachersActivos() {
      this.cargar = true
      return this.$http
        .get('academico.teachers.activos')
        .then((response) => {
          this.teachersActivos = response.data || []
        })
        .catch((error) => {
          this.validarError(error.response && error.response.data ? error.response.data.message : 'Error al cargar teachers')
        })
        .finally(() => {
          this.cargar = false
        })
    },

    extraerIdsTeachersRolClases(filas) {
      const ids = new Set()
      for (const row of filas || []) {
        if (row.deleted == 1) continue
        const t1 = idNum(row.id_teacher != null ? row.id_teacher : row.id_Teacher)
        const t2 = idNum(row.id_teacher_2)
        if (t1 > 0) ids.add(t1)
        if (t2 > 0) ids.add(t2)
        for (const { slot } of construirChequeosOficiales(row)) {
          const n = idNum(row[slot])
          if (n > 0) ids.add(n)
        }
      }
      return ids
    },

    /**
     * Consulta el rol de clases del ciclo (equivalente a VisualizarAsistenciaTeacher.getRol / RolesTeachers.consultar).
     * Body: objeto `ciclo` del autocomplete (id_ciclo, id_ciclo_relacionado, ciclo, …).
     */
    cargarRolDeClases() {
      if (!this.ciclo) {
        return Promise.reject(new Error('Sin ciclo'))
      }
      this.cargar = true
      return this.$http
        .post('rol.clases', this.ciclo)
        .then((response) => {
          const data = response.data || {}
          this.respuestaRolClasesCompleta = data
          this.filasRolCiclo = Array.isArray(data.respuesta) ? data.respuesta : []
          const ids = this.extraerIdsTeachersRolClases(this.filasRolCiclo)
          this.listaTeachers = this.teachersActivos.filter((t) => ids.has(t.id_usuario))
          this.modoLista = 'ciclo'
        })
        .catch((error) => {
          this.respuestaRolClasesCompleta = null
          this.filasRolCiclo = []
          this.validarError(error.response && error.response.data ? error.response.data.message : 'Error al consultar el rol de clases')
        })
        .finally(() => {
          this.cargar = false
        })
    },

    consultarPorCiclo() {
      if (!this.ciclo) {
        return this.validarErrorDirecto('Selecciona un ciclo')
      }
      this.cargarRolDeClases()
    },

    mostrarTodosActivos() {
      this.respuestaRolClasesCompleta = null
      this.filasRolCiclo = []
      this.listaTeachers = [...this.teachersActivos]
      this.modoLista = 'todos'
    },
  },
}
</script>
